import React, { useContext } from "react";

import { useMsal, useAccount } from "@azure/msal-react";
import { loginRequest } from "./config";

import {
  Layout,
  Menu,
  Typography,
  Breadcrumb,
  Divider,
  Button,
  Space,
} from "antd";
import { Link } from "react-router-dom";

import { ReactComponent as UHLogo } from "./uh.svg";
const { Header, Content, Footer } = Layout;

const TopMenu: React.FC = () => {
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  return (
    <Space className="header-menu">
      {account ? (
        <>
          {account.name!} |
          <Button size="small" onClick={() => instance.logout()}>
            Logout
          </Button>
        </>
      ) : (
        <Button
          type="primary"
          onClick={() => instance.loginRedirect(loginRequest)}
        >
          Login
        </Button>
      )}
    </Space>
  );
};

type BreadcrumbTrail = { title: string; path?: string }[];

interface AppPageLayoutProps {
  title?: string;
  breadcrumbs?: BreadcrumbTrail;
}

export const AppPageLayout: React.FC<AppPageLayoutProps> = ({
  title,
  breadcrumbs,
  children,
}) => {
  return (
    <>
      <Layout className="layout">
        <Layout>
          <Header className="header">
            <div className="uh-logo">
              <UHLogo style={{ width: "225px" }} />
            </div>
            <TopMenu />
          </Header>
          <Content className="layout-content-surround">
            <div className="layout-content">
              {title && (
                <>
                  <Typography.Title>{title}</Typography.Title>
                  <Divider />
                </>
              )}
              {children}
            </div>
          </Content>
        </Layout>
      </Layout>
    </>
  );
};
